<template>
    <div class="columns is-gapless">
        <div class="column has-text-centered has-background-white" @click="chooseUnterkonstruktion">
            <div :class="['nav-box', {'is-active' : isActiveStep1 }]" align="center">
                <div class="circle tick" v-if="isActiveStep1"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>1. Anwendungsbereich</div>
            </div>
        </div>
        <div class="column has-text-centered has-background-white">
            <div class="status" />
            <div :class="['nav-box', {'is-active' : isActiveStep2 }]" align="center" @click="chooseMaterial">
                <div class="circle tick" v-if="isActiveStep2"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>2. Schraubenmaterial</div>
            </div>
        </div>
        <div class="column has-text-centered has-background-white">
            <div class="status" />
            <div :class="['nav-box', {'is-active' : isActiveStep3 }]" align="center" @click="chooseSchraubenart">
                <div class="circle tick" v-if="isActiveStep3"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>3. Schraubenfunktion</div>
            </div>
        </div>
        <div class="column has-text-centered has-background-white">
            <div class="status" />
            <div :class="['nav-box', {'is-active' : isActiveStep4 }]" align="center" @click="chooseProduct">
                <div class="circle tick" v-if="isActiveStep4"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>4. Schraube</div>
            </div>
        </div>
         <div class="column has-text-centered has-background-white">
            <div class="status" />
            <div :class="['nav-box', {'is-active' : isActiveStep5 }]" align="center" @click="productDetails">
                <div class="circle tick" v-if="isActiveStep5"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>5. Schraubendetails</div>
            </div>
        </div>
        <div class="column has-text-centered has-background-white">
            <div class="status" />
            <div :class="['nav-box', {'is-active' : isActiveStep6 }]" align="center" @click="goToSummary">
                <div class="circle tick" v-if="isActiveStep6"><img src="@/assets/images/tick.svg" /></div>
                <div v-else class="circle" />
                <div>6. Zusammenfassung</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        cart () {
            return this.$store.state.cart
        },
        isActiveStep1 () {
            return this.currentStep === 'Unterkonstruktion' || this.currentStep === 'Material' || this.currentStep === 'Schraubenart' || this.currentStep === 'Produkte' || this.currentStep === 'ProductDetails' || this.currentStep === 'Summary'
        },
        isActiveStep2 () {
            return this.currentStep === 'Material' || this.currentStep === 'Schraubenart' || this.currentStep === 'Produkte' || this.currentStep === 'ProductDetails' || this.currentStep === 'Summary'
        },
        isActiveStep3 () {
            return this.currentStep === 'Schraubenart' || this.currentStep === 'Produkte' || this.currentStep === 'ProductDetails' || this.currentStep === 'Summary'
        },
        isActiveStep4 () {
            return this.currentStep === 'Produkte' || this.currentStep === 'ProductDetails' || this.currentStep === 'Summary'
        },
        isActiveStep5 () {
           return this.currentStep === 'ProductDetails' || this.currentStep === 'Summary'
        },
        isActiveStep6 () {
            return this.currentStep === 'Summary'
        },
        currentProduct: {
            set (val) {
                this.$store.commit('setCurrentProduct', val)
            },
            get () {
                return this.$store.state.currentProduct
            }
        }
    },
    methods: {
        chooseMaterial () {
            this.currentStep = 'Material'
        },
        chooseUnterkonstruktion () {
            this.currentProduct = null
            this.currentStep = 'Unterkonstruktion'
        },
        chooseSchraubenart () {
            this.currentProduct = null
            this.currentStep = 'Schraubenart'
        },
        chooseProduct () {
            this.currentProduct = null
            this.currentStep = 'Produkte'
        },
        productDetails () {
            if (!this.currentProduct) {
            alert("Bitte wähle zunächst ein Produkt")
            return
        } else {
            return this.currentStep = 'ProductDetails'
            }
        },
        goToSummary () {
        if (!this.currentProduct) {
            alert("Bitte wähle zunächst ein Produkt")
            return
        } else {
            return this.currentStep = 'Summary'
            }
        }
    }
}
</script>
<style lang="sass">
@import "../assets/sass/variables.sass"

.nav-box
    padding: 10px
    .circle
        width: 20px
        height: 20px
        border-radius: 50%
        background: $grey
        &.tick
            display: grid
            place-items: center
            background: $primary
    &.is-active
        background-color: $grey-light
        border-bottom: 4px solid $primary
</style>
